/**
 * Create store system divecePatch - agentPatch
 * 시스템 > 패치 관리 > 장비 관리 > Agent 패치
 *
 * @since 2018-11-08
 * @author devp018
 * @modify jupil.Go <devp018>
 */

import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

export const state = () => ({
  apiUrl: `${apiPrefix}/patch/device/agent-patch`, // 에이전트 패치 API
  patchDeviceList: [], // 패치 대상 장비 목록
  deviceIdList: [],
  errorMessage: null
})

export const mutations = {
  setErrorMessage (state, data) {
    state.errorMessage = data.msg
    const msg = {
      error: data.msg
    }
    state.errorMessage = msg
  },
  clearPatchDeviceData (state) {
    state.patchDeviceList = []
  },
  // 패치 대상 장비 목록 설정
  setPatchDeviceData (state, data) {
    state.patchDeviceList = data
    state.deviceIdList = _.values(_.mapValues(data, 'device_id'))
  }
}

export const actions = {
  // 패치 대상 장비 목록 조회
  async getDevicePatchData ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrl)
    if (code === 'ok') {
      commit('setPatchDeviceData', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  // 대상 장비에 패치 수행
  async setDevicePatchData ({commit, state}) {
    const {code, result} = await this.$axios.$post(state.apiUrl, { device_list: state.deviceIdList })
    if (code === 'ok') {
      return true
    }
    commit('setErrorMessage', result)
    return false
  }
}

export const getters = {
}

export const strict = false
